export const getYearLabel = (ano) => {
    if (ano === null || ano === undefined || ano === '') {
        return 'Não identificado';
    }

    return ano;
};
